import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getDeployment } from '@/redux/modules/config';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackFollowedPriceResultsSearch = () =>
    useTrackConversion({ goal: KameleoonGoalData.FollowedPriceResultsSearch });

export const useTrackSavedPriceResultsItem = () =>
    useTrackConversion({ goal: KameleoonGoalData.SavedPriceResultsItem });

export const useTrackItemCardClickedPriceResults = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(() => {
        track(TrackingEvents.Item.ItemCardClicked, {
            pageName: getAmplitudePageNameFromPath(pathname),
            source: 'price_results_page',
            url: getFullUrl(deployment, pathname),
        });
    }, [deployment, pathname]);
};

export const useTrackMainItemClickedPriceResults = () =>
    useTrackConversion({ goal: KameleoonGoalData.MainItemClickedPriceResults });
